export const DEFAULT_PAGINATION_PAGE = {
  items: [],
  pageNumber: 1,
  pageSize: 20,
  pagesTotal: 0,
  itemsTotal: 0,
  itemCount: 0,
  firstItemNumber: 1,
};
